import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_422_19774)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.27698 18.7769C10.0198 21.6615 15.3924 20.9658 18.277 17.2229C21.1616 13.4801 20.4658 8.10753 16.723 5.22294C12.9802 2.33835 7.60761 3.03408 4.72302 6.77691C3.46035 8.41525 2.88369 10.3659 2.94833 12.2834",
				stroke: "#636C7B",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 9V13.2781H15.2781",
				stroke: "#636C7B",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3 13.9999L0.401924 10.9999L5.59808 10.9999L3 13.9999Z",
				fill: "#636C7B"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_422_19774",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgHistory;
